import _construct from "/zeit/45515ec9/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/zeit/45515ec9/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export var doNotProxy = Symbol('doNotProxy');

function isObject(value) {
  return typeof value === 'object' && !Array.isArray(value) && value !== null;
}

var hasWarnedConstructor = false;
var currentEffectId = 0;

function wrapEffect(target, prop, path, cb) {
  var func = function func() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var effectId = currentEffectId++;
    return cb({
      func: target[prop].bind(target),
      effectId: effectId,
      name: path,
      method: prop,
      args: args
    });
  };

  return new Proxy(func, {
    construct: function construct(_, args) {
      if (!hasWarnedConstructor) {
        console.warn("EFFECTS - It is highly recommended to create a custom effect, exposing a method that deals with the instantiation of \"".concat(path, ".").concat(prop.toString(), "\". It improves readability and debugability of your app"));
        hasWarnedConstructor = true;
      }

      return _construct(target[prop], _toConsumableArray(args));
    }
  });
}

function createProxyGetHandler(path, cb) {
  return function (target, prop) {
    if (typeof target[prop] === 'function') {
      return wrapEffect(target, prop, path, cb);
    }

    if (isObject(target[prop])) {
      return new Proxy(target[prop], {
        get: createProxyGetHandler(path ? path + '.' + prop.toString() : prop.toString(), cb)
      });
    }

    return target[prop];
  };
}

export function proxifyEffects(effects, cb) {
  return new Proxy(effects, {
    get: createProxyGetHandler('', cb)
  });
}